'use client';

import { useEffect } from 'react';
import { captureFirstTouchAttribution } from '@/utils/attribution';
import { isEmbedPath } from '@/utils/isEmbedPath';

/**
 * Captures first-touch attribution (referrer + UTMs) on the visitor's first
 * page load so it can be attached to later form submissions. Renders nothing.
 */
export default function AttributionTracker() {
  useEffect(() => {
    // An iframe embed view is not a site visit — don't record first touch.
    if (isEmbedPath(window.location.pathname)) return;
    captureFirstTouchAttribution();
  }, []);

  return null;
}
